import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { LiveChatEvent, LiveChatService } from './live-chat.service';
import { TokenStorageService } from './token-storage.service';

@Injectable({ providedIn: 'root' })
export class LiveChatNotificationService {
  readonly unreadCount$ = new BehaviorSubject<number>(0);
  readonly toast$ = new Subject<string>();
  private started = false;

  constructor(
    private liveChat: LiveChatService,
    private router: Router,
    private tokenStorage: TokenStorageService,
  ) {}

  start(): void {
    if (this.started) return;
    this.started = true;
    this.liveChat.connect();
    this.liveChat.events$.subscribe(event => this.handleEvent(event));
  }

  clear(): void {
    this.unreadCount$.next(0);
  }

  private handleEvent(event: LiveChatEvent): void {
    const onMessagesScreen = this.router.url.startsWith('/telephony/messages') || this.router.url.startsWith('/csr/messages');
    const fromCitizen = event.message?.senderType === 'CITIZEN';
    const newSession = event.type === 'SESSION_STARTED';
    const transferredToMe = event.type === 'SESSION_TRANSFERRED'
      && Number(event.session?.assignedAgentUserId) === Number(this.tokenStorage.getUserId());

    if (!fromCitizen && !newSession && !transferredToMe) return;

    if (!onMessagesScreen) {
      this.unreadCount$.next(this.unreadCount$.value + 1);
    }

    const name = event.session?.citizenName || event.message?.senderName || 'Citizen';
    this.toast$.next(transferredToMe
      ? `Live chat transferred from ${name}`
      : newSession ? `New live chat from ${name}` : `New citizen message from ${name}`);
  }
}
